import { render, staticRenderFns } from "./CheckGovernment.vue?vue&type=template&id=f24355dc&scoped=true"
import script from "./CheckGovernment.vue?vue&type=script&lang=js"
export * from "./CheckGovernment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24355dc",
  null
  
)

export default component.exports